import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';

export function isWhatsappBrowserEnabledForAccount(account) {
  if (!account) return false;

  if (typeof account.whatsapp_browser_enabled === 'boolean') {
    return account.whatsapp_browser_enabled;
  }

  return account.custom_attributes?.whatsapp_browser_enabled === true;
}

/**
 * Whether the current workspace may use WhatsApp browser session channels.
 */
export function useWhatsappBrowserChannel() {
  const { currentAccount } = useAccount();

  const whatsappBrowserEnabled = computed(() =>
    isWhatsappBrowserEnabledForAccount(currentAccount.value)
  );

  return { whatsappBrowserEnabled };
}
